import { defineComponent as _defineComponent } from 'vue'
import BCXPagination from '@/components/molecules/BCXPagination.vue';
import {
  PropType, ref, toRefs
} from 'vue';
import usePaginationHelper from '@/mixins/usePaginationHelper';
import { syncRef, useVModel } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXPaginatedContent',
  props: {
  array: {
    type: Array as PropType<unknown[]>,
    default: () => []
  },
  pageSize: {
    type: Number,
    required: true
  },
  page: {
    type: Number,
    default: 1
  },
  gap: {
    type: String,
    default: '32px'
  },
  paginationIsAlwaysShown: Boolean,
  hidePagination: Boolean,
},
  setup(__props) {

const props = __props;



const { array, pageSize } = toRefs(props);
const currentPage = ref(1);
const pageVM = useVModel(props, 'page');
syncRef(currentPage, pageVM);

const { slicedArray, total } = usePaginationHelper(pageSize, currentPage, array);


return { __sfc: true,props, array, pageSize, currentPage, pageVM, slicedArray, total, BCXPagination }
}

})